"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var PermissionResource = /** @class */ (function (_super) {
    tslib_1.__extends(PermissionResource, _super);
    function PermissionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PermissionResource.endpoint = '/permissions';
    PermissionResource.MODEL_NAME = 'permission';
    return PermissionResource;
}(base_1.default));
exports.default = PermissionResource;
//# sourceMappingURL=permission.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/permission.js
// module id = f1jd
// module chunks = 0